import { getCurrentInstance } from "@vue/composition-api";
export const useBootstrapModal = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error("must be called in setup");
  return {
    modal: vm.proxy.$bvModal
  };
};